import { memo } from 'react';

import type { ModelLead } from '@app/api/Leads/types';
import type { SalesFunnelFilterDto } from '@app/api/SalesFunnels/types';
import { LeadFunnelStagesControl } from '@app/pages/Leads/ui/components/LeadFunnelStagesControl';

import { useLeadsRegistryFunnelStages } from '../../../../hooks/useLeadsRegistryFunnelStages';

import type { FC } from 'react';

interface LeadsRegistryFunnelStageCellProps {
  lead: ModelLead;
  funnels: SalesFunnelFilterDto[];
  isOptionsLoading?: boolean;
}

const LeadsRegistryFunnelStageCellComponent: FC<
  LeadsRegistryFunnelStageCellProps
> = ({ lead, funnels, isOptionsLoading = false }) => {
  const { stages, options, isMutating, addStage, changeStage, deleteStage } =
    useLeadsRegistryFunnelStages({ lead, funnels });

  return (
    <LeadFunnelStagesControl
      stages={stages}
      options={options}
      isLoading={isOptionsLoading}
      isDisabled={isMutating}
      onAddStage={addStage}
      onChangeStage={changeStage}
      onDeleteStage={deleteStage}
    />
  );
};

export const LeadsRegistryFunnelStageCell = memo(
  LeadsRegistryFunnelStageCellComponent
);
